const apiURL = process.env.API_URL || 'http://localhost:4000'
//const apiURL = process.env.API_URL || 'http://www.hexapla.org'

export default {
  apiURL,
}
